module.exports = __webpack_public_path__ + "img/chara_line_7_white.7ab5993d.png";